import React from 'react';
import { WrappedComponentProps, injectIntl, useIntl } from 'react-intl';
/*models*/
import { IOrderHub } from '../../../../models/order';
import { IOrderStatuses } from '../../../../models/order-statuses';
import * as CON from '../../../common/constants';

/*CSS*/
import './order-tracker-styles.css';

interface ICategoryProps {
    state: IOrderStatuses;
    chevCatClass: (category: string) => string;
    warningDisplay: (category: string) => boolean;
    setPTagStyle: (category: string) => string;
    exceptionCheck: (category: string) => boolean;
    changeCategory: (category: string) => void;
    viewButtonCheck: (category: string) => boolean;
    currentEvent: IOrderHub;
    cancelled: boolean;
}

export const OutForDeliveryCategory = ({
    state,
    chevCatClass,
    warningDisplay,
    setPTagStyle,
    exceptionCheck,
    changeCategory,
    viewButtonCheck,
    currentEvent,
    cancelled,
}: ICategoryProps) => {
    const intl = useIntl();
    return (
        <div
            className={chevCatClass(CON.OUT_FOR_DELIVERY)}
            id={
                state.outForDelivery.isActive
                    ? 'out-for-delivery-active'
                    : 'out-for-delivery'
            }
        >
            <div className="reRotate">
                {state.outForDelivery.isCompleted && !cancelled && (
                    <>
                        <i className="check-mark ofd fas fa-check-circle fa-lg"></i>
                        <div className="my-secret-div ofd"></div>
                    </>
                )}
                {warningDisplay(CON.OUT_FOR_DELIVERY) && (
                    <>
                        <i className="exclamation-1 ex-out-for-delivery fas fa-exclamation-circle fa-lg"></i>
                        <div className="my-secret-div"></div>
                    </>
                )}
                <p className={setPTagStyle(CON.OUT_FOR_DELIVERY)}>
                    {intl.formatMessage({
                        id: CON.OUT_FOR_DELIVERY_ID,
                        defaultMessage: CON.OUT_FOR_DELIVERY,
                    })}
                </p>

                <div className="completed-div">
                    {state.outForDelivery.isCompleted && !cancelled && (
                        <p
                            className={
                                !state.outForDelivery.isActive &&
                                !state.outForDelivery.isCompleted
                                    ? 'p-no-margin blue'
                                    : 'p-no-margin'
                            }
                        >
                            {intl.formatMessage({
                                id: CON.COMPLETED,
                                defaultMessage: CON.COMPLETED,
                            })}
                        </p>
                    )}
                    {currentEvent.eventCatagory === CON.OUT_FOR_DELIVERY &&
                        currentEvent.exceptionLevel === '' &&
                        !cancelled &&
                        !state.outForDelivery.isCompleted && (
                            <p
                                className={
                                    !state.outForDelivery.isActive
                                        ? 'p-no-margin blue'
                                        : 'p-no-margin'
                                }
                            >
                                {intl.formatMessage({
                                    id: CON.IN_PROGRESS_ID,
                                    defaultMessage: CON.IN_PROGRESS,
                                })}
                            </p>
                        )}
                    {exceptionCheck(CON.OUT_FOR_DELIVERY) && (
                        <p
                            className={
                                state.outForDelivery.exception1
                                    ? 'p-no-margin exception-1'
                                    : 'p-no-margin exception-2'
                            }
                        >
                            {intl.formatMessage({
                                id: CON.EXCEPTION,
                                defaultMessage: CON.EXCEPTION,
                            })}
                        </p>
                    )}
                    {currentEvent.eventCatagory === CON.OUT_FOR_DELIVERY &&
                        cancelled && (
                            <p className="p-no-margin exception-2">
                                {intl.formatMessage({
                                    id: CON.CANCELLED,
                                    defaultMessage: CON.CANCELLED,
                                })}
                            </p>
                        )}
                    {viewButtonCheck(CON.OUT_FOR_DELIVERY) && (
                        <button
                            className="delete-items-pad-left"
                            id="view-details-btn-out-for-delivery"
                            onClick={() => {
                                changeCategory(CON.OUT_FOR_DELIVERY);
                            }}
                        >
                            {intl.formatMessage({
                                id: CON.VIEW_DETAIL_ID,
                                defaultMessage: CON.VIEW_DETAIL,
                            })}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OutForDeliveryCategory;
